<template>
    <div class="c-loader-star">
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 1495.8 1408.6"
            style="enable-background:new 0 0 1495.8 1408.6;"
            xml:space="preserve"
        >
            <path
                d="M892.6,0H591.8v541.3L97.1,362.7L0,627.3l505.2,170.3l-316.4,437.2l242.7,173.8l316.4-451.4l316.4,451.4l242.7-173.8
	L990.7,797.6l505.2-170.3l-98-271.4L892.6,541.3L892.6,0L892.6,0z"
            />
        </svg>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.c-loader-star {
    text-align: center;

    svg {
        transform: scale(0.9);
        animation: pulse 1s infinite;
        width: 200px;
        margin: 50px 0 50px 0;
    }
}

@keyframes pulse {
    10% {
        transform: scale(1);
    }
}
</style>
